import Vue from 'vue';
import axios from 'axios';
import router from '@/router';

export const defaultRemoteUrl = process.env.NODE_ENV === 'production' ?
  '/' :
  'http://localhost:8080/api/';

export const ajax = axios.create({
  timeout: 6e5,
  baseURL: defaultRemoteUrl
});

const vm = new Vue();

ajax.interceptors.request.use(
  config => {
    const token = localStorage.getItem('Authorization');
    const secondLang = localStorage.getItem('secondLang') || 'en';

    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers.secondLang) {
      config.headers.secondLang = secondLang;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

ajax.interceptors.response.use(
  response => {
    if (response.data.errorCode === '20001') {
      vm.$Message.error(response.data.msg);

      sessionStorage.setItem('versionStatus', 'end');
      location.reload();
      return Promise.reject(response.data.msg);
    }

    if (response.data.errorCode === '02012001') {
      vm.$Message.error(response.data.msg);

      router.push({
        name: 'account'
      });

      return Promise.reject(response.data.msg);
    }

    if (response.data.code === '1') {
      vm.$Message.error(response.data.msg);

      return Promise.reject(response.data.msg);
    }
    return response;
  },
  error => {
    if (error.response &&
      error.response.data.error &&
      error.response.data.error.message &&
      error.response.data.error.details) {
      vm.$Message.destroy();
      vm.$Message.error(error.response.data.error.message);
    }
    else if (error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.message) {
      vm.$Message.destroy();
      vm.$Message.error(error.response.data.error.message);
    }
    else if (!error.response) {
      vm.$Message.destroy();
      // vm.$Message.error('请求失败');
    }

    return Promise.reject(error);
  }
);
